import { useEffect, memo } from 'react';
import { useSelector } from 'react-redux';
import useBentoStream from 'hooks/useBentoStream';
import {
  selectCartSlug,
  selectCartIsGroupOrder
} from 'bento-ordering/cart/selectors';
import { useSubscribeToGroupOrderEvents } from 'bento-ordering/group_ordering/hooks/index';

const BentoStreamManager = memo(() => {
  const cartSlug = useSelector(selectCartSlug);
  const isGroupOrder = useSelector(selectCartIsGroupOrder);
  const { subscribeToGroupOrderEvents } = useSubscribeToGroupOrderEvents();

  const {
    getRoomConnection,
    disconnectFromRoom,
    subscribeToEvent
  } = useBentoStream();

  useEffect(() => {
    const connectToRoom = async () => {
      await getRoomConnection(cartSlug);
      // subscribe to events
      subscribeToGroupOrderEvents(subscribeToEvent);
    };

    // currently only using websockets for group ordering
    if (cartSlug && isGroupOrder) {
      connectToRoom();
    }

    return disconnectFromRoom;
  }, [
    cartSlug,
    getRoomConnection,
    isGroupOrder,
    disconnectFromRoom,
    subscribeToEvent,
    subscribeToGroupOrderEvents
  ]);

  return null;
});

BentoStreamManager.displayName = 'BentoStreamManager';

export default BentoStreamManager;
